var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEloraLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166.482,
    height: 41.7,
    viewBox: "0 0 166.482 41.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1741ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18ead2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(11745.395 -8733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(10.238 619.129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M28.75-4.6V-8.25a31.373,31.373,0,0,1-8.05.95H18.2c-4.8,0-6-1.3-6-5v-1.25h8.15c3.35,0,5.2-1.4,5.2-3.9V-20.9H12.2a58.248,58.248,0,0,1,.35-5.85h10.5c4,0,5.75-2.2,5.75-5.5V-34.5H10c-3.35,0-6,1.3-6.65,5.7a67.1,67.1,0,0,0-.6,9.3v5.8C2.75-4.15,7.75.45,16.8.45h3.9C26.8.45,28.75-1.45,28.75-4.6Zm20,.6V-7.3h-2.1c-2.65,0-4-.75-4-3.2V-30.45c0-4.65-2-6.55-6.15-6.55H33.15V-9.1c0,6.5,4.35,9.5,9.4,9.5C45.55.4,48.75-.65,48.75-4Zm2.15-9.15c0,8.1,6.4,13.9,14.25,13.9,9.5,0,14.95-5.8,14.95-14.8a14.038,14.038,0,0,0-14.25-14.2C57.2-28.25,50.9-22.25,50.9-13.15Zm19.8-.05c0,3.8-1.95,6.55-4.95,6.55-3.35,0-5.45-2.3-5.45-7.6,0-3.75,2.35-6.5,4.95-6.5C68.55-20.75,70.7-18.15,70.7-13.2Zm31.2-7.2v-3.5c0-2.55-2.2-4.5-6.95-4.5-6.25,0-10,4.4-10,9.95V-6.5c0,4.6,2.5,6.5,6.6,6.5h2.6V-16.45c0-3.35,1.8-4.5,4.1-4.5a8.581,8.581,0,0,1,3.35.55Zm26.95,8.3v-4.25c0-8.1-4.95-11.95-12.55-11.95-7.85,0-11.4,3.4-11.4,6.8v3.35h.25c1.95-1.8,3.85-3,9-3,3.75,0,5.5.55,5.5,2.8v1.15H118.3c-10,0-14.4,3.1-14.4,9.2,0,6.25,6.45,8.75,11.75,8.75C125.65.75,128.85-2.1,128.85-12.1Zm-9,2.85c0,2.5-1.5,3.35-3.2,3.35-2.65,0-3.75-.9-3.75-2.65,0-1.85,1.45-2.75,5.05-2.75h1.9Z",
    transform: "translate(-11718 8150.871)",
    fill: "#1741ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AI",
    transform: "translate(-11759.997 8111.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M17.649,7.51l1.195,3.318a13.145,13.145,0,0,0,7.909,7.909l3.318,1.195a.34.34,0,0,1,0,.64l-3.318,1.195a13.145,13.145,0,0,0-7.909,7.909l-1.195,3.318a.34.34,0,0,1-.64,0l-1.195-3.318a13.145,13.145,0,0,0-7.909-7.909L4.589,20.571a.34.34,0,0,1,0-.64l3.318-1.195a13.145,13.145,0,0,0,7.909-7.909L17.01,7.51a.34.34,0,0,1,.64,0Z",
    transform: "translate(0 2.578)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M25.538,2.115l.606,1.68a6.661,6.661,0,0,0,4,4l1.68.606a.172.172,0,0,1,0,.324l-1.68.606a6.661,6.661,0,0,0-4,4l-.606,1.68a.172.172,0,0,1-.324,0l-.606-1.68a6.661,6.661,0,0,0-4-4l-1.68-.606a.172.172,0,0,1,0-.324L20.6,7.8a6.661,6.661,0,0,0,4-4l.606-1.68A.172.172,0,0,1,25.538,2.115Z",
    transform: "translate(7.045 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M25.538,21.287l.606,1.68a6.661,6.661,0,0,0,4,4l1.68.606a.172.172,0,0,1,0,.324l-1.68.606a6.661,6.661,0,0,0-4,4l-.606,1.68a.172.172,0,0,1-.324,0l-.606-1.68a6.661,6.661,0,0,0-4-4l-1.68-.606a.172.172,0,0,1,0-.324l1.68-.606a6.661,6.661,0,0,0,4-4l.606-1.68A.172.172,0,0,1,25.538,21.287Z",
    transform: "translate(7.045 9.352)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AI-2",
    "data-name": "AI",
    transform: "translate(-11759.997 8111.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M17.649,7.51l1.195,3.318a13.145,13.145,0,0,0,7.909,7.909l3.318,1.195a.34.34,0,0,1,0,.64l-3.318,1.195a13.145,13.145,0,0,0-7.909,7.909l-1.195,3.318a.34.34,0,0,1-.64,0l-1.195-3.318a13.145,13.145,0,0,0-7.909-7.909L4.589,20.571a.34.34,0,0,1,0-.64l3.318-1.195a13.145,13.145,0,0,0,7.909-7.909L17.01,7.51a.34.34,0,0,1,.64,0Z",
    transform: "translate(0 2.578)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M25.538,2.115l.606,1.68a6.661,6.661,0,0,0,4,4l1.68.606a.172.172,0,0,1,0,.324l-1.68.606a6.661,6.661,0,0,0-4,4l-.606,1.68a.172.172,0,0,1-.324,0l-.606-1.68a6.661,6.661,0,0,0-4-4l-1.68-.606a.172.172,0,0,1,0-.324L20.6,7.8a6.661,6.661,0,0,0,4-4l.606-1.68A.172.172,0,0,1,25.538,2.115Z",
    transform: "translate(7.045 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M25.538,21.287l.606,1.68a6.661,6.661,0,0,0,4,4l1.68.606a.172.172,0,0,1,0,.324l-1.68.606a6.661,6.661,0,0,0-4,4l-.606,1.68a.172.172,0,0,1-.324,0l-.606-1.68a6.661,6.661,0,0,0-4-4l-1.68-.606a.172.172,0,0,1,0-.324l1.68-.606a6.661,6.661,0,0,0,4-4l.606-1.68A.172.172,0,0,1,25.538,21.287Z",
    transform: "translate(7.045 9.352)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEloraLogo);
export default __webpack_public_path__ + "static/media/elora_logo.8bf8d38f4346609427af33d0bfb81c68.svg";
export { ForwardRef as ReactComponent };